import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/Button";
import { useClubOnboarding } from "./hooks/useClubOnboarding";

/** Manual entry remains available after scoped dismissal, including after the
 * first team exists. A failed/loading query never claims the club is empty. */
export function OnboardingResumeCard() {
  const setup = useClubOnboarding();
  if (
    setup.loading ||
    setup.error ||
    !setup.allowed ||
    setup.state.completed ||
    (!setup.empty && !setup.resumable && !setup.state.pending)
  )
    return null;
  return (
    <section data-testid="onboarding-resume" className="rounded bg-surface p-6">
      <p className="eyebrow">Club setup</p>
      <h2>
        {setup.team
          ? "Finish setup when you’re ready."
          : "Your club is ready for its first team."}
      </h2>
      <p className="mt-2 text-sm text-ink-muted">
        {setup.team
          ? "Your team is saved. Season setup and staff invitations can wait."
          : "You’ve left setup for now. Add your first team whenever you’re ready."}
      </p>
      <Button asChild className="mt-4">
        <Link to="/welcome">
          {setup.team || setup.state.pending || setup.state.draft.team.name
            ? "Continue setup"
            : "Create first team"}
        </Link>
      </Button>
    </section>
  );
}
